import { render, staticRenderFns } from "./AvaliationItemForm.vue?vue&type=template&id=0c37a8cc"
import script from "./AvaliationItemForm.vue?vue&type=script&lang=js"
export * from "./AvaliationItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports